import { useReactiveVar } from '@apollo/client'
import { walletBalancesVar } from 'shared/store/balance-store'
import type { WalletBalance } from '../types'

/** Balances of the user's linked wallets, keyed by wallet address. */
export const useWalletBalances = (): Record<string, WalletBalance> =>
  useReactiveVar(walletBalancesVar)
